import { MessageViewModel } from '@trovata/app/features/chat-assistant/models/chat-assistant-messages';

export class AddChatMessage {
	static readonly type: string = '[ChatSessions] AddChatMessage';
	constructor(
		public contextKey: string,
		public message: MessageViewModel
	) {}
}

export class UpdateChatMessage {
	static readonly type: string = '[ChatSessions] UpdateChatMessage';
	constructor(
		public contextKey: string,
		public tempId: string,
		public patch: Partial<MessageViewModel>
	) {}
}

export class HydrateChatConversation {
	static readonly type: string = '[ChatSessions] HydrateChatConversation';
	constructor(
		public contextKey: string,
		public messages: MessageViewModel[],
		public sessionId: string
	) {}
}

export class ClearChatConversation {
	static readonly type: string = '[ChatSessions] ClearChatConversation';
	constructor(public contextKey: string) {}
}

export class SetChatSessionId {
	static readonly type: string = '[ChatSessions] SetChatSessionId';
	constructor(
		public contextKey: string,
		public sessionId: string
	) {}
}

// Re-keys a conversation when its server session id is assigned (CHAT_NEW_KEY becoming chat:<sessionId>).
export class MigrateChatConversation {
	static readonly type: string = '[ChatSessions] MigrateChatConversation';
	constructor(
		public fromKey: string,
		public toKey: string,
		public sessionId: string
	) {}
}

export class ClearChatSessionsState {
	static readonly type: string = '[ChatSessions] ClearChatSessionsState';
}

// Dispatched after the API confirms a soft-delete; clears the in-memory conversation only if
// the deleted session is the active one, so the panel doesn't keep showing a deleted chat.
export class RemoveChatSession {
	static readonly type: string = '[ChatSessions] RemoveChatSession';
	constructor(
		public contextKey: string,
		public sessionId: string
	) {}
}
